/* ============================================================
   NOCTURNAL — LP „2 Masken + Ohrstöpsel geschenkt“ · Kaufen
   Galerie, Kacheln, Farbwahl, Countdown, Kaufleiste, Warenkorb.
   Werte aus window.MG (Ende von layout/masken-geschenk.liquid).

   GESCHENK: Den Nachlass rechnet Shopify (Rabatt „Ohrstöpsel
   geschenkt ab 2 Masken“). Hier werden die Ohrstöpsel mit _geschenk
   in den Korb gelegt und genau diese Zeile wieder entfernt, sobald
   weniger als zwei Masken drin sind. Bestätigt wird das Geschenk nur,
   wenn Shopify es wirklich angerechnet hat.

   TRACKING wie Duo-LP: AddToCart meldet Shopifys Facebook-Kanal
   selbst; ViewContent steht unten, mit dem Wert des Sets.
   ============================================================ */
(function () {
  'use strict';

  var D = window.MG;
  if (!D || !D.maske) { return; }

  var $  = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };
  var leise = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* Optionswerte kommen englisch oder deutsch („Black“/„schwarz“) — ein Schlüssel. */
  var ALIAS = {
    black: 'black', schwarz: 'black', cream: 'cream', creme: 'cream',
    burgundy: 'burgundy', burgund: 'burgundy', bordeaux: 'burgundy',
    white: 'white', weiss: 'white', 'weiß': 'white'
  };
  var NAME = { black: 'Schwarz', cream: 'Creme', burgundy: 'Bordeaux', white: 'Weiß' };
  function norm(w) { var k = String(w || '').toLowerCase().trim(); return ALIAS[k] || k; }
  function farbname(w) { return NAME[norm(w)] || w; }
  function euro(c) {
    return (c / 100).toLocaleString('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' €';
  }
  function esc(t) {
    return String(t == null ? '' : t).replace(/[&<>"']/g, function (z) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[z];
    });
  }

  var MASKE = {};
  D.maske.varianten.forEach(function (v) { var k = norm(v.farbe); if (!MASKE[k]) { MASKE[k] = v; } });
  var PLUGS = {};
  ((D.plugs && D.plugs.varianten) || []).forEach(function (v) { PLUGS[v.id] = v; });

  /* Zustand aus dem DOM: beim Zurück-Navigieren stellt der Browser die Auswahl wieder her. */
  var Z = { tier: 'zwei', m1: D.start, m2: D.start, plugs: null, aktiv: 'm1' };
  ['m1', 'm2'].forEach(function (r) { var c = $('input[name="' + r + '"]:checked'); if (c) { Z[r] = c.value; } });
  var tc = $('input[name="tier"]:checked'); if (tc) { Z.tier = tc.value; }
  var pc = $('input[name="plugs"]:checked'); if (pc) { Z.plugs = +pc.value; }

  function aktionLaeuft() {
    return !!(D.aktion.an && D.plugs && (!D.aktion.ende || Date.now() / 1000 < D.aktion.ende));
  }

  var toast = $('#toast');
  function melde(t) {
    if (!toast) { return; }
    toast.textContent = t;
    toast.classList.add('an');
    clearTimeout(melde.t);
    melde.t = setTimeout(function () { toast.classList.remove('an'); }, 2800);
  }
  function beschaeftigt(knopf, an) {
    if (!knopf) { return; }
    if (an) { knopf.setAttribute('aria-busy', 'true'); } else { knopf.removeAttribute('aria-busy'); }
  }

  /* ---- 1 — Galerie: nur die Fotos der gewählten Farbe ---- */
  var track = $('#gal-track'), dots = $('#gal-dots'), chip = $('#gal-chip');
  var slides = track ? $$('.gal__s', track) : [];
  var sichtbar = [];

  function punkte() {
    if (!dots) { return; }
    dots.innerHTML = sichtbar.length > 1
      ? sichtbar.map(function (_, i) { return '<i' + (i === 0 ? ' class="an"' : '') + '></i>'; }).join('')
      : '';
  }
  function galerie(farbe, text) {
    if (!track) { return; }
    if (slides.some(function (s) { return s.dataset.farbe === farbe; })) {
      slides.forEach(function (s) { s.hidden = s.dataset.farbe !== farbe; });
    }
    sichtbar = slides.filter(function (s) { return !s.hidden; });
    track.scrollLeft = 0;
    punkte();
    if (chip && text) { chip.textContent = text; }
  }
  function index() { return Math.round(track.scrollLeft / Math.max(1, track.clientWidth)); }
  function blaettern(d) {
    var i = Math.max(0, Math.min(sichtbar.length - 1, index() + d));
    track.scrollTo({ left: i * track.clientWidth, behavior: leise ? 'auto' : 'smooth' });
  }
  if (track) {
    var galTickt = false;
    track.addEventListener('scroll', function () {
      if (galTickt) { return; }
      galTickt = true;
      requestAnimationFrame(function () {
        galTickt = false;
        var i = index();
        $$('i', dots).forEach(function (p, n) { p.classList.toggle('an', n === i); });
      });
    }, { passive: true });
    track.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { e.preventDefault(); blaettern(1); }
      if (e.key === 'ArrowLeft') { e.preventDefault(); blaettern(-1); }
    });
    var gl = $('#gal-l'), gr = $('#gal-r');
    if (gl) { gl.addEventListener('click', function () { blaettern(-1); }); }
    if (gr) { gr.addEventListener('click', function () { blaettern(1); }); }
    /* Fehlt ein Bild (Datei ersetzt), fliegt die Kachel raus statt leer zu bleiben. */
    slides.forEach(function (s) {
      var img = $('img', s);
      if (img) {
        img.addEventListener('error', function () {
          s.remove();
          slides = slides.filter(function (x) { return x !== s; });
          sichtbar = slides.filter(function (x) { return !x.hidden; });
          punkte();
        });
      }
    });
  }

  function chipText(r) {
    var n = NAME[Z[r]] || Z[r];
    return Z.tier === 'zwei' ? (r === 'm1' ? 'Maske 1 · ' : 'Maske 2 · ') + n : n;
  }

  /* ---- 2 — Kacheln und Farbwahl ---- */
  function beschriften(r) {
    var g = $('.grp[data-reihe="' + r + '"]');
    if (!g) { return; }
    var c = $('input:checked', g), b = $('[data-name]', g);
    if (c && b) { b.textContent = c.dataset.name; }
  }

  function tierSetzen(t) {
    Z.tier = t;
    $$('.tile').forEach(function (el) { el.classList.toggle('an', el.dataset.tier === t); });
    var inp = $('input[name="tier"][value="' + t + '"]');
    if (inp && !inp.checked) { inp.checked = true; }
    var m2 = $('.grp[data-reihe="m2"]'), pl = $('.grp[data-reihe="plugs"]'), lab = $('.grp[data-reihe="m1"] [data-lab]');
    if (m2) { m2.hidden = t !== 'zwei'; }
    if (pl) { pl.hidden = t !== 'zwei'; }
    if (lab) { lab.textContent = t === 'zwei' ? 'Maske 1' : 'Farbe'; }
    if (t !== 'zwei') { Z.aktiv = 'm1'; }
    galerie(Z[Z.aktiv], chipText(Z.aktiv));
    alles();
  }

  $$('input[name="tier"]').forEach(function (inp) {
    inp.addEventListener('change', function () { tierSetzen(inp.value); });
  });
  $$('input[name="m1"], input[name="m2"]').forEach(function (inp) {
    inp.addEventListener('change', function () {
      Z[inp.name] = inp.value;
      Z.aktiv = inp.name;
      beschriften(inp.name);
      galerie(inp.value, chipText(inp.name));
      alles();
    });
  });
  $$('input[name="plugs"]').forEach(function (inp) {
    inp.addEventListener('change', function () { Z.plugs = +inp.value; beschriften('plugs'); alles(); });
  });

  /* ---- 3 — Was an der Auswahl hängt: Knopftext, Set, Leiste, Finale ---- */
  function miniMaske(k) { return (D.maske.bilder[k] || {}).mini || D.maske.notbild; }
  function plugsBild() { var v = PLUGS[Z.plugs]; return (v && v.bild) || (D.plugs && D.plugs.bild); }

  function alles() {
    var zwei = Z.tier === 'zwei', gesch = aktionLaeuft();

    var kt = $('#kauf-txt');
    if (kt) {
      kt.textContent = zwei ? (gesch ? '2 Masken + Geschenk sichern' : '2 Masken in den Warenkorb')
                            : 'In den Warenkorb · ' + euro(D.preise.eins);
    }

    ['m1', 'm2'].forEach(function (r) {
      var b = D.maske.bilder[Z[r]] || {};
      $$('[data-set="' + r + '"]').forEach(function (img) {
        if (b.haupt && img.getAttribute('src') !== b.haupt) { img.src = b.haupt; }
      });
      $$('[data-set-n="' + r + '"]').forEach(function (el) { el.textContent = NAME[Z[r]] || Z[r]; });
    });
    var pb = plugsBild();
    if (pb) { $$('[data-set="plugs"]').forEach(function (img) { if (img.getAttribute('src') !== pb) { img.src = pb; } }); }

    var fin = $('#fin-set');
    if (fin) {
      fin.innerHTML = [miniMaske(Z.m1), miniMaske(Z.m2)].concat(gesch && pb ? [pb] : [])
        .filter(Boolean).map(function (s) { return '<img src="' + s + '" alt="" width="66" height="66">'; }).join('');
    }

    var n = $('#leiste-n'), p = $('#leiste-p'), alt = $('#leiste-alt'), lb = $('#leiste-bilder'), lk = $('#leiste-kauf');
    if (n) { n.textContent = zwei ? (gesch ? '2 Masken + Ohrstöpsel' : '2 Masken') : '1 Maske · ' + (NAME[Z.m1] || Z.m1); }
    if (p) { p.textContent = euro(zwei ? D.preise.zwei : D.preise.eins); }
    if (alt) { alt.hidden = !(zwei && gesch && D.preise.wert > 0); }
    if (lk) { lk.textContent = zwei ? 'Jetzt sichern' : 'In den Warenkorb'; }
    if (lb) {
      var bilder = zwei ? [miniMaske(Z.m1), miniMaske(Z.m2)].concat(gesch && pb ? [pb] : []) : [miniMaske(Z.m1)];
      lb.innerHTML = bilder.filter(Boolean).map(function (s) { return '<img src="' + s + '" alt="" width="38" height="38">'; }).join('');
    }

    document.dispatchEvent(new CustomEvent('mg:auswahl', { detail: { tier: Z.tier, m1: Z.m1, m2: Z.m2, plugs: Z.plugs } }));
  }

  /* ---- 4 — Countdown auf das ECHTE Aktionsende (= Enddatum am Rabatt).
     Kein Schein-Timer: nach UWG-Anhang Z 7 per se unzulässig. ---- */
  var uhren = $$('[data-uhr]');
  function zwei0(n) { return n < 10 ? '0' + n : '' + n; }
  function aktionVorbei() {
    D.aktion.an = false;
    $$('.bar, .uhr, .fin__uhr, #geschenk, .tile__gesch, .tile__badge, .tile__pct, .tile__ohne, .grp--gesch, .bed, .fin__gesch')
      .forEach(function (el) { el.hidden = true; });
    $$('.tile__preis s, #leiste-alt, .fin__preis s').forEach(function (el) { el.hidden = true; });
    alles();
    /* Einmal neu laden, damit Liquid den Stand ohne Aktion zeichnet. */
    try {
      if (sessionStorage.getItem('mg-ende') === String(D.aktion.ende)) { return; }
      sessionStorage.setItem('mg-ende', String(D.aktion.ende));
    } catch (e) { return; }
    location.reload();
  }
  var uhrTimer = null;
  function ticken() {
    var rest = Math.floor(D.aktion.ende - Date.now() / 1000);
    if (rest <= 0) { clearInterval(uhrTimer); aktionVorbei(); return; }
    var tg = Math.floor(rest / 86400), st = Math.floor(rest % 86400 / 3600), mi = Math.floor(rest % 3600 / 60), se = rest % 60;
    var t = (tg > 0 ? tg + ' ' + (tg === 1 ? 'Tag' : 'Tagen') + ' · ' : '') + zwei0(st) + ':' + zwei0(mi) + ':' + zwei0(se);
    uhren.forEach(function (u) { u.textContent = t; });
  }
  if (D.aktion.an && D.aktion.ende) { ticken(); uhrTimer = setInterval(ticken, 1000); }

  /* ---- 5 — Warenkorb ---- */
  function post(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) {
      return r.json().then(function (j) {
        if (!r.ok) { throw new Error((j && (j.description || j.message)) || 'cart'); }
        return j;
      });
    });
  }
  function korbLesen() {
    return fetch(D.routen.cart, { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); });
  }
  function fehler(e) {
    melde(e && e.message && e.message !== 'cart' ? e.message : 'Hat leider nicht geklappt – bitte noch einmal versuchen');
  }

  function lage(k) {
    var l = { masken: 0, maskeZeile: null, plugs: [], gesch: null };
    (k.items || []).forEach(function (i) {
      if (i.product_id === D.maske.id) { l.masken += i.quantity; if (!l.maskeZeile) { l.maskeZeile = i; } }
      if (D.plugs && i.product_id === D.plugs.id) {
        l.plugs.push(i);
        if (i.properties && i.properties._geschenk) { l.gesch = i; }
      }
    });
    return l;
  }
  /* Weniger als zwei Masken, aber die geschenkte Zeile liegt noch drin:
     raus damit. Selbst gekaufte Ohrstöpsel (ohne _geschenk) bleiben. */
  function geschenkPruefen(k) {
    var l = lage(k);
    if (l.masken < 2 && l.gesch) {
      return post(D.routen.change, { id: l.gesch.key, quantity: 0 }).then(function (neu) {
        melde('Ohrstöpsel entfernt – geschenkt gibt es sie ab zwei Masken');
        return neu;
      });
    }
    return Promise.resolve(k);
  }

  function zeilenHtml(k) {
    if (!k.items || !k.items.length) { return '<p class="drw__leer">Dein Warenkorb ist noch leer.</p>'; }
    return k.items.map(function (i) {
      var istGesch = i.properties && i.properties._geschenk;
      /* Masken: Studiofoto der Zeilenfarbe statt der schwarzen Nachttisch-Szene. */
      var studio = i.product_id === D.maske.id && D.maske.bilder[norm((i.variant_options || [])[0] || i.variant_title)];
      var src = studio && studio.mini ? studio.mini
        : (i.image ? i.image + (i.image.indexOf('?') > -1 ? '&' : '?') + 'width=160' : '');
      var bild = src ? '<img src="' + src + '" alt="" width="64" height="64" loading="lazy">' : '';
      var vt = i.variant_title && i.variant_title !== 'Default Title' ? farbname(i.variant_title.split(' / ')[0]) : '';
      var gratis = i.final_line_price === 0 && i.original_line_price > 0;
      var preis = gratis ? '<em>Geschenkt</em><s>' + euro(i.original_line_price) + '</s>'
        : (i.final_line_price < i.original_line_price
            ? euro(i.final_line_price) + '<s>' + euro(i.original_line_price) + '</s>'
            : euro(i.final_line_price));
      var menge = istGesch ? '<span class="zeile__g">Geschenk</span>'
        : '<span class="menge"><button type="button" data-menge="-1" data-key="' + esc(i.key) + '" data-q="' + i.quantity + '" aria-label="Eins weniger">−</button>' +
          '<span>' + i.quantity + '</span>' +
          '<button type="button" data-menge="1" data-key="' + esc(i.key) + '" data-q="' + i.quantity + '" aria-label="Eins mehr">+</button></span>';
      return '<div class="zeile"><div class="zeile__bild">' + bild + '</div><div class="zeile__m">' +
        '<p class="zeile__n">' + esc(i.product_title) + '</p>' +
        (vt ? '<p class="zeile__v">' + esc(vt) + '</p>' : '') +
        '<div class="zeile__u">' + menge + '<span class="zeile__p">' + preis + '</span></div>' +
        '<button class="zeile__weg" type="button" data-weg="' + esc(i.key) + '">Entfernen</button>' +
        '</div></div>';
    }).join('');
  }

  function geschHtml(l) {
    if (!aktionLaeuft() || l.masken === 0) { return ''; }
    if (l.masken === 1) {
      var vt = l.maskeZeile.variant_title;
      var f = vt && vt !== 'Default Title' ? ' · ' + farbname(vt) : '';
      return '<p class="gesch__t">Noch eine Maske, dann sind die Ohrstöpsel geschenkt.</p>' +
        '<p class="gesch__x">Ab zwei Masken legen wir die Ohrstöpsel im Wert von ' + euro(D.aktion.wert) +
        ' kostenlos dazu – Farben frei kombinierbar.</p>' +
        '<div class="gesch__r"><button class="gesch__btn" type="button" data-g-maske="' + l.maskeZeile.variant_id + '">' +
        'Zweite Maske dazu' + esc(f) + '</button></div>';
    }
    if (!l.plugs.length) {
      var kn = D.plugs.varianten.filter(function (v) { return v.da; }).map(function (v) {
        return '<button class="gesch__btn" type="button" data-g-plugs="' + v.id + '">' + esc(farbname(v.farbe)) + '</button>';
      }).join('');
      if (!kn) { return ''; }
      return '<p class="gesch__t">Deine Ohrstöpsel sind geschenkt.</p>' +
        '<p class="gesch__x">Welche Farbe hättest du gern? Bei einer Rücksendung gehen beide Masken und die Ohrstöpsel zurück.</p>' +
        '<div class="gesch__r">' + kn + '</div>';
    }
    var gespart = l.plugs.reduce(function (s, i) { return s + Math.max(0, i.original_line_price - i.final_line_price); }, 0);
    return gespart > 0 ? '<p class="gesch__t">✓ Ohrstöpsel geschenkt – du sparst ' + euro(gespart) + '</p>' : '';
  }

  var drw = $('#drw'), schleier = $('#schleier'), drwOffen = false, vorFokus = null;

  function zeichnen(k) {
    $('#drw-zeilen').innerHTML = zeilenHtml(k);
    var h = geschHtml(lage(k)), g = $('#drw-gesch');
    g.innerHTML = h;
    g.hidden = !h;
    g.classList.toggle('gesch--ok', h.indexOf('✓') > -1);
    $('#drw-summe').textContent = euro(k.total_price || 0);
    var spar = $('#drw-spar');
    if (k.total_discount > 0) { spar.textContent = 'Du sparst ' + euro(k.total_discount); spar.hidden = false; }
    else { spar.hidden = true; }
    var nz = $('#korb-n');
    if (nz) {
      nz.textContent = k.item_count || 0;
      if (k.item_count) { nz.removeAttribute('data-null'); } else { nz.setAttribute('data-null', ''); }
    }
    var kasse = $('#drw-kasse');
    if (kasse) { kasse.disabled = !k.item_count; }
    return k;
  }

  function auf() {
    drwOffen = true;
    vorFokus = document.activeElement;
    drw.classList.add('an'); schleier.classList.add('an');
    drw.setAttribute('aria-hidden', 'false');
    document.body.classList.add('drw-offen');
    leisteZeigen();
    setTimeout(function () { var z = $('#drw-zu'); if (z) { z.focus(); } }, 60);
  }
  function zu() {
    drwOffen = false;
    drw.classList.remove('an'); schleier.classList.remove('an');
    drw.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('drw-offen');
    leisteZeigen();
    if (vorFokus && vorFokus.focus) { vorFokus.focus(); }
  }
  $('#drw-zu').addEventListener('click', zu);
  schleier.addEventListener('click', zu);
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && drwOffen) { zu(); } });

  function korbOeffnen() {
    korbLesen().then(geschenkPruefen).then(zeichnen).then(auf).catch(function () { auf(); });
  }
  var ka = $('#korb-auf');
  if (ka) { ka.addEventListener('click', korbOeffnen); }
  var n0 = $('#korb-n');
  if (n0 && n0.textContent.trim() === '0') { n0.setAttribute('data-null', ''); }

  function aendern(key, menge, knopf) {
    beschaeftigt(knopf, true);
    post(D.routen.change, { id: key, quantity: menge })
      .then(geschenkPruefen).then(zeichnen).catch(fehler)
      .then(function () { beschaeftigt(knopf, false); });
  }
  function hinzu(items, knopf) {
    beschaeftigt(knopf, true);
    post(D.routen.add, { items: items })
      .then(korbLesen).then(geschenkPruefen).then(zeichnen).catch(fehler)
      .then(function () { beschaeftigt(knopf, false); });
  }
  drw.addEventListener('click', function (e) {
    var b = e.target.closest('button');
    if (!b) { return; }
    if (b.dataset.menge) { aendern(b.dataset.key, Math.max(0, +b.dataset.q + +b.dataset.menge), b); }
    else if (b.dataset.weg) { aendern(b.dataset.weg, 0, b); }
    else if (b.dataset.gMaske) { hinzu([{ id: +b.dataset.gMaske, quantity: 1 }], b); }
    else if (b.dataset.gPlugs) { hinzu([{ id: +b.dataset.gPlugs, quantity: 1, properties: { _geschenk: 'ja' } }], b); }
  });

  /* "zwei": beide Masken plus Ohrstöpsel — außer es liegen schon welche im Korb;
     dann rechnet Shopify den Nachlass dort an (ein Paar pro Bestellung). */
  function inKorb(tier, knopf) {
    var v1 = MASKE[Z.m1], v2 = MASKE[Z.m2];
    if (!v1 || !v1.da || (tier === 'zwei' && (!v2 || !v2.da))) {
      melde('Diese Farbe ist gerade ausverkauft – bitte eine andere wählen');
      return;
    }
    beschaeftigt(knopf, true);
    korbLesen().then(function (k) {
      var items = [];
      if (tier !== 'zwei') { items.push({ id: v1.id, quantity: 1 }); }
      else if (v1.id === v2.id) { items.push({ id: v1.id, quantity: 2 }); }
      else { items.push({ id: v1.id, quantity: 1 }); items.push({ id: v2.id, quantity: 1 }); }
      if (tier === 'zwei' && aktionLaeuft() && !lage(k).plugs.length) {
        var pv = PLUGS[Z.plugs];
        if (pv && pv.da) { items.push({ id: pv.id, quantity: 1, properties: { _geschenk: 'ja' } }); }
      }
      return post(D.routen.add, { items: items });
    })
      .then(korbLesen).then(geschenkPruefen).then(zeichnen)
      .then(function () { auf(); })
      .catch(fehler)
      .then(function () { beschaeftigt(knopf, false); });
  }

  var kauf = $('#kauf');
  if (kauf) { kauf.addEventListener('click', function () { inKorb(Z.tier, kauf); }); }
  var lk0 = $('#leiste-kauf');
  if (lk0) { lk0.addEventListener('click', function () { inKorb(Z.tier, lk0); }); }
  var fk = $('#fin-kauf');
  if (fk) {
    fk.addEventListener('click', function () {
      if (Z.tier !== 'zwei') { tierSetzen('zwei'); }
      inKorb('zwei', fk);
    });
  }

  /* ---- 6 — Kaufleiste: an, sobald der Hero-Knopf nicht im Bild ist (auch beim
     Laden auf kleinen Handys); aus bei sichtbarem Finale-Knopf oder offenem Korb. ---- */
  var leisteEl = $('#leiste'), heroSicht = true, finSicht = false;
  function leisteZeigen() {
    if (!leisteEl) { return; }
    var an = !heroSicht && !finSicht && !drwOffen;
    leisteEl.classList.toggle('an', an);
    leisteEl.setAttribute('aria-hidden', String(!an));
    if (lk0) { lk0.tabIndex = an ? 0 : -1; }
  }
  if ('IntersectionObserver' in window) {
    if (kauf) {
      new IntersectionObserver(function (e) { heroSicht = e[0].isIntersecting; leisteZeigen(); }, { threshold: 0.5 }).observe(kauf);
    }
    if (fk) {
      new IntersectionObserver(function (e) { finSicht = e[0].isIntersecting; leisteZeigen(); }, { threshold: 0.2 }).observe(fk);
    }
  } else {
    window.addEventListener('scroll', function () { heroSicht = window.scrollY < 500; leisteZeigen(); }, { passive: true });
  }

  /* Für mg-extras.js (Quiz): dieselben Wege, keine zweite Logik. */
  window.MGK = {
    inKorb: inKorb, tierSetzen: tierSetzen, aktionLaeuft: aktionLaeuft, euro: euro, melde: melde,
    zustand: function () { return { tier: Z.tier, m1: Z.m1, m2: Z.m2, plugs: Z.plugs }; },
    name: function (k) { return NAME[k] || k; }
  };

  /* Start */
  beschriften('m1'); beschriften('m2'); beschriften('plugs');
  tierSetzen(Z.tier);

  /* ViewContent mit dem Wert des beworbenen Sets, nicht der Einzelmaske:
     Meta soll auf den Warenkorb optimieren, den die Anzeige verspricht. */
  if (typeof fbq !== 'undefined' && D.preise.zwei > 0) {
    var v0 = MASKE[Z.m1];
    fbq('track', 'ViewContent', {
      content_ids: [String(v0 ? v0.id : D.maske.id)],
      content_type: 'product',
      content_name: '2 Masken + Ohrstöpsel geschenkt',
      value: D.preise.zwei / 100,
      currency: D.waehrung
    });
  }
})();
